import "./tableHeadingTitle.scss";

const TableHeadingTitle = (props: any) => {
  const { children } = props;
  return <span className="title__text">{children}</span>;
};

export default TableHeadingTitle;
